module.exports = __webpack_public_path__ + "img/1756265569914-image.jpg.07555531.webp";